"use client"

import { useEffect } from 'react'

/**
 * 处理 chunk 加载失败的全局错误处理器
 * 当检测到 chunk 加载失败时，自动刷新页面以获取最新版本
 */
export function ChunkErrorHandler() {
	useEffect(() => {
		const handleChunkError = (event: ErrorEvent) => {
			const errorMessage = event.message || event.error?.message || ''

			// 检测 chunk 加载失败的错误
			if (
				errorMessage.includes('Loading chunk') ||
				errorMessage.includes('Failed to fetch dynamically imported module') ||
				errorMessage.includes('Importing a module script failed')
			) {
				console.warn('检测到 chunk 加载失败，准备刷新页面:', errorMessage)

				// 防止重复刷新
				const lastRefresh = sessionStorage.getItem('chunk-error-refresh')
				const now = Date.now()

				if (lastRefresh) {
					const timeSinceLastRefresh = now - parseInt(lastRefresh, 10)
					// 如果 5 秒内已经刷新过，不再刷新，避免无限循环
					if (timeSinceLastRefresh < 5000) {
						console.warn('最近已刷新过，跳过本次刷新')
						return
					}
				}

				// 记录刷新时间
				sessionStorage.setItem('chunk-error-refresh', now.toString())

				// 延迟刷新，给用户一点时间看到错误（如果有的话）
				setTimeout(() => {
					window.location.reload()
				}, 100)
			}
		}

		// 监听全局错误事件
		window.addEventListener('error', handleChunkError, true)

		// 监听未处理的 Promise 拒绝（webpack chunk 加载失败通常会触发这个）
		const handleUnhandledRejection = (event: PromiseRejectionEvent) => {
			const reason = event.reason
			const errorMessage = typeof reason === 'string'
				? reason
				: reason?.message || ''

			if (
				errorMessage.includes('Loading chunk') ||
				errorMessage.includes('Failed to fetch dynamically imported module') ||
				errorMessage.includes('Importing a module script failed')
			) {
				console.warn('检测到 chunk 加载失败（Promise rejection），准备刷新页面:', errorMessage)

				// 防止重复刷新
				const lastRefresh = sessionStorage.getItem('chunk-error-refresh')
				const now = Date.now()

				if (lastRefresh) {
					const timeSinceLastRefresh = now - parseInt(lastRefresh, 10)
					if (timeSinceLastRefresh < 5000) {
						console.warn('最近已刷新过，跳过本次刷新')
						return
					}
				}

				sessionStorage.setItem('chunk-error-refresh', now.toString())

				// 阻止默认的错误处理
				event.preventDefault()

				setTimeout(() => {
					window.location.reload()
				}, 100)
			}
		}

		window.addEventListener('unhandledrejection', handleUnhandledRejection)

		return () => {
			window.removeEventListener('error', handleChunkError, true)
			window.removeEventListener('unhandledrejection', handleUnhandledRejection)
		}
	}, [])

	return null
}

